<rask-button-stack class="align-left">
  <rask-button
    class="col-12"
    icon="fas fa-plus"
    color="tertiary"
    [disabled]="!canCreateNewExtent()"
    (click)="createNewExtent()">
    {{texts.createNewExtent}}
  </rask-button>
  <rask-button
    class="col-12"
    icon="fas fa-sync"
    color="tertiary"
    [disabled]="!canCalculateExtents()"
    (click)="calculateExtents()">
    {{texts.calculateExtents}}
  </rask-button>
  <rask-selector
    class="col-12"
    label="{{texts.scale}}"
    [values]="scales"
    [(ngModel)]="selectedScale"
    (change)="scaleChanged($event)"
    [viewFormatter]="scaleViewFormatter"
    [hidden]="!canChangeScale()"
    [placeholder]="customScaleText">
  </rask-selector>
  @if (canDeleteSelectedExtent()) {
    <rask-button
      class="col-12 pt-1"
      icon="far fa-trash-alt"
      color="tertiary"
      (click)="deleteSelectedExtent()"
      negative>
      {{texts.deleteSelectedExtent}}
    </rask-button>
  }
</rask-button-stack>
